import { lazy } from "react";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import AlarmOnIcon from "@mui/icons-material/AlarmOn";
import AlarmIcon from "@mui/icons-material/Alarm";
import AssessmentIcon from "@mui/icons-material/Assessment";
import LocalCarWashIcon from "@mui/icons-material/LocalCarWash";

import ChecklistIcon from "@mui/icons-material/Checklist";
import PersonIcon from "@mui/icons-material/Person";

import MedicalInformationIcon from "@mui/icons-material/MedicalInformation";
import TaxiAlertIcon from "@mui/icons-material/TaxiAlert";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";

import BadgeIcon from "@mui/icons-material/Badge";
import FeedbackIcon from "@mui/icons-material/Feedback";

import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import SmsIcon from "@mui/icons-material/Sms";

import { Navigate } from "react-router-dom";
import TimeToLeaveIcon from "@mui/icons-material/TimeToLeave";
import CallIcon from "@mui/icons-material/Call";

import HomeIcon from '@mui/icons-material/Home';
import ReportIcon from '@mui/icons-material/Report';
import BookIcon from '@mui/icons-material/Book';

// import ReportIcon from "@mui/icons-material/Report";
// import BookIcon from "@mui/icons-material/Book";
import SpeedIcon from "@mui/icons-material/Speed";

import PersonOffIcon from "@mui/icons-material/PersonOff";

const OTAReport = lazy(() => import("../components/OTAReport").then((module) => ({ default: module.OTAReport })));
const NoShowReport = lazy(() => import("../components/noShowReport").then((module) => ({ default: module.NoShowReport })));
const TripReports = lazy(() => import("../components/TripReports"));
const TripRequestsReport = lazy(() => import("../components/TripRequestsReport"));
const OTDReport = lazy(() => import("../components/OTDReport").then((module) => ({ default: module.OTDReport })));
const EmployeeNoShowReport = lazy(() => import("../components/employeeNoShowReport").then((module) => ({ default: module.EmployeeNoShowReport })));
const EscortReport = lazy(() => import("../components/escortReport").then((module) => ({ default: module.EscortReport })));
const TripRequestAdHocMedReports = lazy(() => import("../components/TripRequestAdMedReport"));
const CancelledTripRequests = lazy(() => import("../components/CancelledTripRequests"));
const AttritionReport = lazy(() => import("../components/attritionReport").then((module) => ({ default: module.AttritionReport })));
const EmployeeReport = lazy(() => import("../components/employeeReport").then((module) => ({ default: module.EmployeeReport })));
const AlertReport = lazy(() => import("../components/alertReport").then((module) => ({ default: module.AlertReport })));
const EmployeeTripRatingReport = lazy(() => import("../components/employeeTripratingReport").then((module) => ({ default: module.EmployeeTripRatingReport })));
const CabArrivalTimeReport = lazy(() => import("../components/cabArrivalTimeReport").then((module) => ({ default: module.CabArrivalTimeReport })));
const SMSReport = lazy(() => import("../components/smsReport").then((module) => ({ default: module.SMSReport })));
const IVRReport = lazy(() => import("../components/ivrReport").then((module) => ({ default: module.IVRReport })));
const SafeHomeReport = lazy(() => import("../components/safeHomeReport").then((module) => ({ default: module.SafeHomeReport })));
const OverspeedReport = lazy(() => import("../components/overSpeedReport"));

const ReportRoute = [
  {
    icon: ContentPasteIcon,
    name: "Reports",
    link: "/reports",
    path: "reports",
    index: 21,
    superAdminView: false,
    permission: "Report-Read",
    children: [
      {
        icon: AlarmOnIcon,
        name: "OTA Report",
        link: "/reports/OTA-report",
        path: "/reports/OTA-report",
        superAdminView: false,
        element: <OTAReport />,
        permission: "Report-Read",
      },
      {
        icon: AlarmIcon,
        name: "OTD Report",
        link: "/reports/OTD-report",
        path: "/reports/OTD-report",
        superAdminView: false,
        element: <OTDReport />,
        permission: "Report-Read",
      },
      {
        icon: AssessmentIcon,
        name: "Trips Report",
        link: "/reports/trip-report",
        path: "/reports/trip-report",
        superAdminView: false,
        element: <TripReports />,
        permission: "Report-Read",
      },
      {
        icon: LocalCarWashIcon,
        name: "TR Report",
        link: "/reports/tr-report",
        path: "/reports/tr-report",
        superAdminView: false,
        element: <TripRequestsReport />,
        permission: "Report-Read",
      },
      {
        icon: ChecklistIcon,
        name: "No show Report",
        link: "/reports/noshow-report",
        path: "/reports/noshow-report",
        superAdminView: false,
        element: <NoShowReport />,
        permission: "Report-Read",
      },
      {
        icon: PersonOffIcon,
        name: "Employee No show Report",
        link: "/reports/employee-noshow-report",
        path: "/reports/employee-noshow-report",
        superAdminView: false,
        element: <EmployeeNoShowReport />,
        permission: "Report-Read",
      },
      {
        icon: PersonIcon,
        name: "Escort Report",
        link: "/reports/escort-report",
        path: "/reports/escort-report",
        superAdminView: false,
        element: <EscortReport />,
        permission: "Report-Read",
      },
      {
        icon: MedicalInformationIcon,
        name: "Ad/Med Report",
        link: "/reports/admed-report",
        path: "/reports/admed-report",
        superAdminView: false,
        element: <TripRequestAdHocMedReports />,
        permission: "Report-Read",
      },
      {
        icon: TaxiAlertIcon,
        name: "Cancelled Report",
        link: "/reports/Cancelled-report",
        path: "/reports/Cancelled-report",
        superAdminView: false,
        element: <CancelledTripRequests />,
        permission: "Report-Read",
      },
      {
        icon: BadgeIcon,
        name: "Employee Report",
        link: "/reports/employee-report",
        path: "/reports/employee-report",
        superAdminView: false,
        element: <EmployeeReport />,
        permission: "Report-Read",
      },
      {
        icon: PersonRemoveIcon,
        name: "Attrition Report",
        link: "/reports/attrition-report",
        path: "/reports/attrition-report",
        superAdminView: false,
        element: <AttritionReport />,
        permission: "Report-Read",
      },
      {
        icon: FeedbackIcon,
        name: "Alert Report",
        link: "/reports/alert-report",
        path: "/reports/alert-report",
        superAdminView: false,
        element: <AlertReport />,
        permission: "Report-Read",
      },
      {
        icon: SpeedIcon,
        name: "Overspeed Report",
        link: "/reports/overspeed-report",
        path: "/reports/overspeed-report",
        superAdminView: false,
        element: <OverspeedReport />,
        permission: "Report-Read",
      },
      {
        icon: ThumbUpIcon,
        name: "Employee Trip Rating Report",
        link: "/reports/employee-trip-rating-report",
        path: "/reports/employee-trip-rating-report",
        superAdminView: false,
        element: <EmployeeTripRatingReport />,
        permission: "Report-Read",
      },
      {
        icon: TimeToLeaveIcon,
        name: "Cab Arrival Time Report",
        link: "/reports/cab-arrival-report",
        path: "/reports/cab-arrival-report",
        superAdminView: false,
        element: <CabArrivalTimeReport />,
        permission: "Report-Read",
      },
      {
        icon: SmsIcon,
        name: "SMS Report",
        link: "/reports/SMS-report",
        path: "/reports/SMS-report",
        superAdminView: false,
        element: <SMSReport />,
        permission: "Report-Read",
      },
      {
        icon: CallIcon,
        name: "IVR Report",
        link: "/reports/IVR-report",
        path: "/reports/IVR-report",
        superAdminView: false,
        element: <IVRReport />,
        permission: "Report-Read",
      },
      {
        icon: HomeIcon,
        name: "Safe Home Report",
        link: "/reports/safe-home-report",
        path: "/reports/safe-home-report",
        superAdminView: false,
        element: <SafeHomeReport />,
        permission: "Report-Read",
      },
      {
        icon: ReportIcon,
        name: "Grievance Report",
        link: "/reports/grievance-report",
        path: "/reports/grievance-report",
        superAdminView: false,
        element: <Navigate to="/grievance-management/grievance" replace />,
        permission: "Grievance-Read",
      },
      {
        icon: BookIcon,
        name: "Event Logs Report",
        link: "/reports/event-logs-report",
        path: "/reports/event-logs-report",
        superAdminView: false,
        element: <Navigate to="/event-logs" replace />,
        permission: "EventLog-Read",
      },
      {
        path: "",
        element: <Navigate to="/reports/OTA-report" replace />,
      },
    ],
  },
];
export default ReportRoute;
